
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire3976"];
var parcelRegister = parcelRequire.register;
parcelRegister("gzUpA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $51efc3ea398c0143$export$2e2bcd8739ae039; });

var $e1vzu = parcelRequire("e1vzu");

var $lf5no = parcelRequire("lf5no");
var $eYBU6 = parcelRequire("eYBU6");
const $51efc3ea398c0143$var$BookFooter = ({ previous: previous, next: next })=>{
    const bookLink = (title)=>`${encodeURIComponent(title.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))}.html`;
    const className = "flex items-center py-1 text-lg text-sky-700 no-underline";
    return /*#__PURE__*/ (0, $e1vzu.jsxs)("footer", {
        className: "fixed bottom-0 z-10 flex w-full justify-between overflow-hidden bg-gradient-to-r from-white to-sky-50/90 px-4 py-2 shadow",
        children: [
            previous ? /*#__PURE__*/ (0, $e1vzu.jsxs)("a", {
                href: bookLink(previous),
                className: className + " pr-3",
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $lf5no.default), {
                        className: "size-8 text-sky-700/40"
                    }),
                    previous
                ]
            }) : /*#__PURE__*/ (0, $e1vzu.jsx)("span", {}),
            next && /*#__PURE__*/ (0, $e1vzu.jsxs)("a", {
                href: bookLink(next),
                className: className + " pl-3",
                children: [
                    next,
                    " ",
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $eYBU6.default), {
                        className: "size-8 text-sky-700/40"
                    })
                ]
            })
        ]
    });
};
var $51efc3ea398c0143$export$2e2bcd8739ae039 = $51efc3ea398c0143$var$BookFooter;

});
parcelRegister("lf5no", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f76f2b54eee5c351$export$2e2bcd8739ae039; });

var $3QbnI = parcelRequire("3QbnI");
function $f76f2b54eee5c351$var$ChevronLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
        clipRule: "evenodd"
    }));
}
const $f76f2b54eee5c351$var$ForwardRef = $3QbnI.forwardRef($f76f2b54eee5c351$var$ChevronLeftIcon);
var $f76f2b54eee5c351$export$2e2bcd8739ae039 = $f76f2b54eee5c351$var$ForwardRef;

});

parcelRegister("eYBU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae741233dfd13442$export$2e2bcd8739ae039; });

var $3QbnI = parcelRequire("3QbnI");
function $ae741233dfd13442$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $ae741233dfd13442$var$ForwardRef = $3QbnI.forwardRef($ae741233dfd13442$var$ChevronRightIcon);
var $ae741233dfd13442$export$2e2bcd8739ae039 = $ae741233dfd13442$var$ForwardRef;

});



//# sourceMappingURL=BookFooter.18d40c5c.js.map
